import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7a873938"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Submit Feedback", -1))
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = { class: "modal-footer" }
const _hoisted_5 = ["disabled"]

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackModal',
  emits: ["close", "submit"],
  setup(__props, { emit: __emit }) {

const feedbackText = ref('');

const emit = __emit;

const submitFeedback = () => {
  if (feedbackText.value.trim()) {
    emit('submit', feedbackText.value);
    feedbackText.value = '';
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "feedback-modal-overlay",
    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
  }, [
    _createElementVNode("div", {
      class: "feedback-modal",
      onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("button", {
          class: "close-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        }, "×")
      ]),
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("textarea", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((feedbackText).value = $event)),
          placeholder: "Share your thoughts, suggestions, or issues...",
          rows: "6"
        }, null, 512), [
          [_vModelText, feedbackText.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-secondary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
        }, "Cancel"),
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: submitFeedback,
          disabled: !feedbackText.value.trim()
        }, " Submit ", 8, _hoisted_5)
      ])
    ])
  ]))
}
}

})